module.exports = __webpack_public_path__ + "static/media/main1.e012bb51.svg";